module.exports = __webpack_public_path__ + "static/media/logo.a2bac5e5.svg";